import React from 'react';

import Icon from '../Icon/Icon';

const UsageBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g fill='none' fillRule='evenodd'>
                <path d='M2 2h44v44H2z' />
                <g fillRule='nonzero'>
                    <path
                        d='M19.494 26.9v12.353h-7.79V26.9h7.79zM28.242 21.53v17.723h-8.484V21.53h8.484zM36.297 32.259v6.994h-7.79v-6.994h7.79z'
                        stroke='#34303D'
                        strokeWidth='2'
                    />
                    <path
                        d='M40.32 40.516H7.68c-.48 0-.867-.448-.867-1 0-.553.388-1 .867-1h32.64c.48 0 .867.447.867 1 0 .552-.388 1-.867 1'
                        fill='#272830'
                    />
                    <path
                        d='M23.845 16.084a.34.34 0 0 1 .31 0l3.156 1.636-.601-3.457a.341.341 0 0 1 .099-.302l2.542-2.442-3.518-.503a.34.34 0 0 1-.255-.185L24 7.678l-1.578 3.153a.34.34 0 0 1-.255.185l-3.518.503 2.542 2.442a.338.338 0 0 1 .1.302l-.602 3.457 3.156-1.636'
                        fill='#00D1D2'
                    />
                    <path
                        d='M24 15.177c.19 0 .382.046.556.137l1.6.83-.301-1.732a1.2 1.2 0 0 1 .354-1.077l1.257-1.209-1.757-.252a1.2 1.2 0 0 1-.907-.655L24 9.619l-.802 1.6a1.2 1.2 0 0 1-.907.656l-1.757.252 1.259 1.209c.29.278.422.68.353 1.077l-.3 1.732 1.599-.83c.174-.091.365-.136.555-.136v-.002zm3.31 3.412a.867.867 0 0 1-.398-.099L24 16.982l-2.912 1.509a.871.871 0 0 1-.912-.07.871.871 0 0 1-.342-.85l.553-3.177-2.34-2.248a.868.868 0 0 1 .479-1.485l3.244-.465 1.454-2.905a.868.868 0 0 1 1.553 0l1.453 2.904 3.244.465a.868.868 0 0 1 .478 1.485l-2.339 2.248.554 3.178a.872.872 0 0 1-.856 1.018z'
                        fill='#272830'
                    />
                </g>
            </g>
        </Icon>
    );
};

export default UsageBlueIcon;
